import React from 'react';

import { CoreSelectProps, ActiveProps } from '../types/props';

import { SelectList } from '@app/store/SelectList/SelectList';
import { SelectRequestParams } from '@app/store/SelectList/ListActions';
import { isEmptyValue } from '@app/store/SelectList/SelectsInterfaces';

export function useActive<
	TValue,
	TStore extends keyof SelectList,
	TParams extends SelectRequestParams<TValue>
>(props: CoreSelectProps<TValue, TStore, TParams>): ActiveProps {
	const [focused, setFocus] = React.useState<boolean>(() => false);

	if (props.multiple) {
		const emptyCheck = props.isEmptyValue ?? isEmptyValue;
		const isEmpty = emptyCheck(props.value);
		const isActive = focused || !isEmpty;

		return {
			isEmpty,
			isActive,
			setFocus,
		};
	}

	const emptyCheck = props.isEmptyValue ?? isEmptyValue;
	const isEmpty = emptyCheck(props.value);
	const isActive = focused || !isEmpty;

	return {
		isEmpty,
		isActive,
		setFocus,
	};
}
